export default __webpack_public_path__ + "static/media/donacion_esterilizacion.3acd3e82.png";